import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-italic",
  "use": "icon-italic-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"icon-italic\"><path d=\"M14.846 2.25H6.538a.154.154 0 00-.153.153v1.228c0 .084.069.153.153.153h3.485l-3 10.432h-3.12a.154.154 0 00-.153.153v1.228c0 .084.07.153.154.153h8.307a.154.154 0 00.154-.153v-1.228a.154.154 0 00-.154-.153H8.623l3-10.432h3.223A.154.154 0 0015 3.631V2.403a.154.154 0 00-.154-.153z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol